var _clipPath, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2928,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard5",
    transform: "matrix(1,0,0,1.03126,-0.339845,4.82771)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2928.34,
    y: -4.681,
    width: 509.38,
    height: 493.953,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2928.34,
    y: -4.681,
    width: 509.38,
    height: 493.953
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.969687,245.43,2303.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.771804,0,0,0.854656,-1115.4,-947.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5213.96,-1640.31C5219.9,-1654.55 5234.96,-1663.97 5251.77,-1663.97C5268.58,-1663.97 5283.64,-1654.55 5289.59,-1640.31L5355.94,-1481.45L5543.25,-1473.38C5560.04,-1472.66 5574.59,-1462.6 5579.78,-1448.12C5584.98,-1433.64 5579.74,-1417.75 5566.62,-1408.23L5420.32,-1301.98L5469.73,-1138.13C5474.16,-1123.44 5468.1,-1107.81 5454.49,-1098.86C5440.9,-1089.91 5422.6,-1089.51 5408.55,-1097.87L5251.77,-1191.06L5095,-1097.87C5080.95,-1089.51 5062.65,-1089.91 5049.05,-1098.86C5035.45,-1107.81 5029.38,-1123.44 5033.81,-1138.13L5083.22,-1301.98L4936.92,-1408.23C4923.81,-1417.75 4918.57,-1433.64 4923.76,-1448.12C4928.96,-1462.6 4943.5,-1472.66 4960.29,-1473.38L5147.6,-1481.45L5213.96,-1640.31Z",
    style: {
      fill: "rgb(255,197,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.74869,0,0,0.74869,2314.2,-3140.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,751.108C1268.83,751.108 1218.37,801.567 1218.37,863.719C1218.37,925.871 1268.83,976.331 1330.98,976.331C1393.13,976.331 1443.59,925.871 1443.59,863.719C1443.59,801.567 1393.13,751.108 1330.98,751.108ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.74869,0,0,0.74869,2149.63,-3140.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,751.108C1268.83,751.108 1218.37,801.567 1218.37,863.719C1218.37,925.871 1268.83,976.331 1330.98,976.331C1393.13,976.331 1443.59,925.871 1443.59,863.719C1443.59,801.567 1393.13,751.108 1330.98,751.108ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 2683.25,
    y: -2369.51,
    width: 509.38,
    height: 488.958,
    style: {
      fill: "rgb(255,197,82)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3198.46,-2375.35L2677.42,-2375.35L2677.42,-1874.72L3198.46,-1874.72L3198.46,-2375.35ZM3192.63,-2369.51L2683.25,-2369.51L2683.25,-1880.55L3192.63,-1880.55L3192.63,-2369.51Z",
    style: {
      fillOpacity: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGuy);
export default __webpack_public_path__ + "static/media/star_guy.faa65839f5175c39957757acf1611171.svg";
export { ForwardRef as ReactComponent };